






















import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import Engine, { Phase } from "@gaia-project/engine";
import { eventDesc } from "../data/event";
import Condition from "./Condition.vue";
import Resource from "./Resource.vue";
import Operator from "./Operator.vue";
import { roundScoringEvents } from "@gaia-project/engine/src/tiles/scoring";

@Component<ScoringTile>({
  components: {
    Condition,
    Operator,
    Resource,
  },
})
export default class ScoringTile extends Vue {
  @Prop()
  round: number;

  get tile() {
    return this.engine.tiles.scorings.round[this.round - 1];
  }

  get event() {
    return roundScoringEvents(this.tile, this.round)[0];
  }

  get reward() {
    return this.event.rewards[0];
  }

  get engine(): Engine {
    return this.$store.state.data;
  }

  get tooltip() {
    return eventDesc(this.event, this.engine.expansions);
  }

  get highlighted() {
    return this.engine.round === this.round && !this.faded;
  }

  get faded() {
    return this.engine.round > this.round || this.engine.phase === Phase.EndGame;
  }
}
